import {
	Popover,
	PopoverContent,
	PopoverMenu,
	PopoverTrigger,
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@exopengithub/exokit";
import { IconLanguage } from "@tabler/icons-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "molecules/languageSelector/LanguageSelector";
import { LANGUAGES } from "src/common/utils/i18n.js";
import { useLanguagePreference } from "src/common/utils/hooks/useLanguagePreference.js";
import { LinkItem } from "./LinkItem";
import { SidebarContext } from "./SidebarContext";

export const LanguageNavItem = () => {
	const { t } = useTranslation();
	const { open } = useContext(SidebarContext);
	const { language, changeLanguage } = useLanguagePreference();
	const currentLanguageLabel =
		LANGUAGES.find((l) => l.code === language)?.label ?? language;

	const trigger = (
		<PopoverTrigger asChild>
			<button
				type="button"
				className="block w-full"
				aria-label={open ? undefined : t("Language")}
				data-testid="sidebar-language-toggle"
			>
				<LinkItem
					icon={<IconLanguage />}
					label={open ? currentLanguageLabel : undefined}
				/>
			</button>
		</PopoverTrigger>
	);

	return (
		<Popover role="menu" placement="right-end">
			{open ? (
				trigger
			) : (
				<Tooltip placement="right">
					<TooltipTrigger asChild>{trigger}</TooltipTrigger>
					<TooltipContent>{t("Language")}</TooltipContent>
				</Tooltip>
			)}
			<PopoverContent>
				<PopoverMenu>
					<div className="p-2">
						<LanguageSelector
							languages={LANGUAGES}
							value={language}
							onChange={changeLanguage}
						/>
					</div>
				</PopoverMenu>
			</PopoverContent>
		</Popover>
	);
};
